// ======================================================================
// 📁 File: BOQHeaderForm.jsx
// ======================================================================

import React, { useEffect, useState } from "react";
import axiosClient from "../../../../../api/axiosClient";

export default function BOQHeaderForm({
  value,
  onChange,
  disabled = false,
}) {
  const [productFamilies, setProductFamilies] = useState([]);
  const [productVariants, setProductVariants] = useState([]);
  const [equipments, setEquipments] = useState([]); // ✅ NEW

  // ------------------------------------------------------------
  // LOAD PRODUCT FAMILIES
  // ------------------------------------------------------------
  useEffect(() => {
    axiosClient
      .get("/api/ppe/masters/product-families")
      .then((res) => {
        setProductFamilies(res.data?.data || []);
      })
      .catch(() => setProductFamilies([]));
  }, []);

  // ------------------------------------------------------------
  // LOAD PRODUCT VARIANTS (OPTIONAL)
  // ------------------------------------------------------------
  // ------------------------------------------------------------
// LOAD PRODUCT VARIANTS FILTERED BY PRODUCT FAMILY
// ------------------------------------------------------------
useEffect(() => {
  let cancelled = false;

  if (!value.product_family_id) {
    setProductVariants([]);
    return;
  }

  axiosClient
    .get("/api/ppe/masters/product-variants")
    .then((res) => {
      if (cancelled) return;

      const responseData = res.data?.data;
      console.log("Equipment API response:", responseData);
      const list = Array.isArray(responseData) ? responseData : [];

      const filtered = list.filter(
        (pv) =>
          String(pv.product_family_id) ===
          String(value.product_family_id)
      );

      setProductVariants(filtered);
    })
    .catch(() => {
      if (!cancelled) setProductVariants([]);
    });

  return () => {
    cancelled = true;
  };
}, [value.product_family_id]);

  // ------------------------------------------------------------
  // ✅ LOAD EQUIPMENT (NEW)
  // ------------------------------------------------------------
  // ------------------------------------------------------------
// LOAD EQUIPMENT
// ------------------------------------------------------------
useEffect(() => {
  let cancelled = false;

  axiosClient
    .get("/api/ppe/masters/equipment")
    .then((res) => {
      if (cancelled) return;

      const responseData = res.data?.data;
      setEquipments(
        Array.isArray(responseData) ? responseData : []
      );
    })
    .catch(() => {
      if (!cancelled) setEquipments([]);
    });

  return () => {
    cancelled = true;
  };
}, []);

// ------------------------------------------------------------
// FILTER EQUIPMENT BY SELECTED PRODUCT VARIANT
// ------------------------------------------------------------
const filteredEquipments = value.product_variant_id
  ? equipments.filter(
      (eq) =>
        String(eq.product_variant_id) ===
        String(value.product_variant_id)
    )
  : [];
  // ------------------------------------------------------------
  // UPDATE FIELD (CONTROLLED)
  // ------------------------------------------------------------
  const updateField = (field, fieldValue) => {
    if (disabled) return;

    onChange({
      ...value,
      [field]: fieldValue,
    });
  };

  return (
    <div className="card mb-3">
      <div className="card-header">
        <strong>BOQ Header</strong>
      </div>

      <div className="card-body">
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "1.5fr 2fr 2fr 1.5fr",
            gap: 16,
          }}
        >
          {/* BOQ Code (AUTO) */}
          <input
            className="form-control"
            disabled
            placeholder="BOQ Code (auto)"
          />

          {/* BOQ Name */}
          <input
            className="form-control"
            placeholder="BOQ Name"
            value={value.boq_name || ""}
            disabled={disabled}
            onChange={(e) =>
              updateField("boq_name", e.target.value)
            }
          />

          {/* PRODUCT FAMILY */}
          <select
            className="form-select"
            value={value.product_family_id || ""}
            disabled={disabled}
            onChange={(e) => {
              const familyId = e.target.value
                ? Number(e.target.value)
                : null;

              onChange({
                ...value,
                product_family_id: familyId,
                product_variant_id: null,
                equipment_id: null,
              });
            }}
          >
            <option value="">
              Select Product Family
            </option>

            {productFamilies.map((pf) => (
              <option key={pf.id} value={pf.id}>
                {pf.name} ({pf.code})
              </option>
            ))}
          </select>

          {/* VERSION */}
          <input
            className="form-control"
            disabled
            placeholder="Version (auto)"
          />

          {/* PRODUCT VARIANT */}
          <select
            className="form-select"
            value={value.product_variant_id || ""}
            disabled={disabled}
            onChange={(e) => {
              const variantId = e.target.value
                ? Number(e.target.value)
                : null;

              onChange({
                ...value,
                product_variant_id: variantId,
                equipment_id: null,
              });
            }}
          >
            <option value="">
              All Variants (Optional)
            </option>

            {productVariants.map((pv) => (
              <option key={pv.id} value={pv.id}>
                {pv.variant_code} – {pv.name}
              </option>
            ))}
          </select>

          {/* ✅ EQUIPMENT (NEW FIELD) */}
          <select
            className="form-select"
            value={value.equipment_id || ""}
            disabled={disabled}
            onChange={(e) =>
              updateField(
                "equipment_id",
                e.target.value
                  ? Number(e.target.value)
                  : null
              )
            }
          >
            <option value="">
              Select Equipment (Optional)
            </option>

            {filteredEquipments.map((eq) => (
              <option key={eq.id} value={eq.id}>
                {eq.equipment_code || eq.code} –{" "}
                {eq.equipment_name || eq.name}
              </option>
            ))}
          </select>

          {/* STATUS */}
          <input
            className="form-control"
            disabled
            placeholder="Status"
          />

          {/* REMARKS */}
          <textarea
            className="form-control"
            rows={2}
            placeholder="Remarks"
            value={value.remarks || ""}
            disabled={disabled}
            onChange={(e) =>
              updateField("remarks", e.target.value)
            }
            style={{
              gridColumn: "1 / span 4",
            }}
          />
        </div>
      </div>
    </div>
  );
}